module.exports = __webpack_public_path__ + "img/62.37098f56.png";